export const RecurrenceType = Object.freeze({
  NONE: 'none',
  DAILY: 'daily',
  WEEKDAYS: 'weekdays',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  CUSTOM: 'custom',
});

export const RecurrenceTypeLabels = {
  [RecurrenceType.NONE]: 'No se repite',
  [RecurrenceType.DAILY]: 'Todos los días',
  [RecurrenceType.WEEKDAYS]: 'Días hábiles (L-V)',
  [RecurrenceType.WEEKLY]: 'Semanal',
  [RecurrenceType.MONTHLY]: 'Mensual',
  [RecurrenceType.YEARLY]: 'Anual',
  [RecurrenceType.CUSTOM]: 'Personalizado',
};

export const RecurrenceTypeOptions = Object.values(RecurrenceType).map(
  (value) => ({
    text: RecurrenceTypeLabels[value],
    value,
  })
);

export const RecurrenceDay = Object.freeze({
  MONDAY: 'mo',
  TUESDAY: 'tu',
  WEDNESDAY: 'we',
  THURSDAY: 'th',
  FRIDAY: 'fr',
  SATURDAY: 'sa',
  SUNDAY: 'su',
});

export const WEEKDAYS = [
  RecurrenceDay.MONDAY,
  RecurrenceDay.TUESDAY,
  RecurrenceDay.WEDNESDAY,
  RecurrenceDay.THURSDAY,
  RecurrenceDay.FRIDAY,
];

export const RecurrenceTypePayload = Object.freeze({
  [RecurrenceType.NONE]: { frequency: null, interval: null, byDay: [] },
  [RecurrenceType.DAILY]: { frequency: 'daily', interval: 1, byDay: [] },
  [RecurrenceType.WEEKDAYS]: {
    frequency: 'weekly',
    interval: 1,
    byDay: [...WEEKDAYS],
  },
  [RecurrenceType.WEEKLY]: { frequency: 'weekly', interval: 1, byDay: [] },
  [RecurrenceType.MONTHLY]: { frequency: 'monthly', interval: 1, byDay: [] },
  [RecurrenceType.YEARLY]: { frequency: 'yearly', interval: 1, byDay: [] },
});

export const RecurrenceEndType = Object.freeze({
  NEVER: 'never',
  UNTIL: 'until',
  COUNT: 'count',
});

export const RecurrenceEndTypeLabels = {
  [RecurrenceEndType.NEVER]: 'Nunca',
  [RecurrenceEndType.UNTIL]: 'En el día',
  [RecurrenceEndType.COUNT]: 'Después de',
};

export const RECURRENCE_DAYS = [
  { id: RecurrenceDay.MONDAY, letter: 'L', label: 'Lunes' },
  { id: RecurrenceDay.TUESDAY, letter: 'M', label: 'Martes' },
  { id: RecurrenceDay.WEDNESDAY, letter: 'X', label: 'Miércoles' },
  { id: RecurrenceDay.THURSDAY, letter: 'J', label: 'Jueves' },
  { id: RecurrenceDay.FRIDAY, letter: 'V', label: 'Viernes' },
  { id: RecurrenceDay.SATURDAY, letter: 'S', label: 'Sábado' },
  { id: RecurrenceDay.SUNDAY, letter: 'D', label: 'Domingo' },
];
